export const merryDatePickerViews = ["day", "month", "year"] as const;

export type MerryDatePickerView = (typeof merryDatePickerViews)[number];
export type MerryDatePickerMode = "single" | "range";

const viewNodeIds: Record<MerryDatePickerView, string> = {
  day: "364:65567",
  month: "364:65569",
  year: "364:66106",
};

export const merryDatePickerFigmaNodeIds = {
  componentSet: "364:65568",
  range: "401:43741",
  ...viewNodeIds,
} as const;

export function getMerryDatePickerFigmaNodeId(
  mode: MerryDatePickerMode,
  view: MerryDatePickerView,
) {
  return mode === "range" && view === "day"
    ? merryDatePickerFigmaNodeIds.range
    : viewNodeIds[view];
}

export function getMerryDatePickerHeight(view: MerryDatePickerView) {
  return view === "day" ? 500 : 292;
}

export interface MerryDatePickerDecade {
  end: number;
  start: number;
  years: ReadonlyArray<number>;
}

export function getMerryDatePickerDecade(year: number): MerryDatePickerDecade {
  const start = Math.floor(year / 10) * 10;

  return {
    end: start + 9,
    start,
    years: Array.from({ length: 12 }, (_, index) => start - 1 + index),
  };
}
